var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Master')))]), _c('v-row', {
    staticClass: "py-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('KeyValue', {
    staticClass: "px-4",
    attrs: {
      "k": _vm.$t('Stamina'),
      "v": _vm.master.m_Stamina
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('KeyValue', {
    staticClass: "px-4",
    attrs: {
      "k": _vm.$t('Battle Party Cost'),
      "v": _vm.master.m_BattlePartyCost
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('KeyValue', {
    staticClass: "px-4",
    attrs: {
      "k": _vm.$t('Friend Limit'),
      "v": _vm.master.m_FriendLimit
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('KeyValue', {
    staticClass: "px-4",
    attrs: {
      "k": _vm.$t('Support Limit'),
      "v": _vm.master.m_SupportLimit
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('KeyValue', {
    staticClass: "px-4",
    attrs: {
      "k": _vm.$t('Weapon Limit'),
      "v": _vm.master.m_WeaponLimit
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('KeyValue', {
    staticClass: "px-4",
    attrs: {
      "k": _vm.$t('Training Slot Num'),
      "v": _vm.master.m_TrainingSlotNum
    }
  })], 1)], 1), _c('v-slider', {
    staticClass: "px-4",
    attrs: {
      "min": "1",
      "max": _vm.max
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label"
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Level')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.level))])])];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          on: {
            "click": function click($event) {
              _vm.level = _vm.max;
            }
          }
        }, [_vm._v("mdi-chevron-double-up")])];
      },
      proxy: true
    }, {
      key: "thumb-label",
      fn: function fn(props) {
        return [_vm._v(_vm._s(_vm.exp))];
      }
    }]),
    model: {
      value: _vm.level,
      callback: function callback($$v) {
        _vm.level = $$v;
      },
      expression: "level"
    }
  }), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki._.format('おすすめランク上げ')
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s('おすすめランク上げ') + " - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki._.format('きらら装備')
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s('きらら装備') + " - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1), _c('v-divider'), _vm._l(_vm.$store.state.$db.MasterOrbListArray, function (orb) {
    return [_c('v-divider'), _c('Orb', {
      key: "master-orb-".concat(orb.m_ID),
      attrs: {
        "id": orb.m_ID
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }